import { useRef, useState, useEffect } from "react";

import styles from "./AutoToggle.module.css";

interface AutoToggleProps {
  enabled: boolean;
  onToggle: () => void;
}

export const AutoToggle = ({ enabled, onToggle }: AutoToggleProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isHovered && wrapperRef.current && popoverRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      popoverRef.current.style.right = `${window.innerWidth - rect.right}px`;
      popoverRef.current.style.bottom = `${window.innerHeight - rect.top + 8}px`;
    }
  }, [isHovered]);

  return (
    <div
      ref={wrapperRef}
      className={styles.autoToggleWrapper}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`${styles.autoToggle} ${enabled ? styles.enabled : styles.disabled}`}
        onClick={onToggle}
      >
        <span
          className={`${styles.autoText} ${enabled ? styles.enabled : styles.disabled}`}
        >
          Auto
        </span>
        <div
          className={`${styles.toggleThumb} ${enabled ? styles.enabled : styles.disabled}`}
        />
      </div>
      <div
        ref={popoverRef}
        className={`${styles.popover} ${isHovered ? styles.visible : ""}`}
      >
        {enabled
          ? "Automatic mode is enabled. AI Chat tools configured to follow this setting will execute without confirmation."
          : "Automatic mode is disabled. AI Chat tools configured to follow this setting will show a confirmation prompt before executing."}
      </div>
    </div>
  );
};
